export const INTAKE_FORM_SLOT_KEYS = [
    'contact.name',
    'contact.email',
    'contact.property',
    'contact.group',
];
// How a slot behaves when its value is already known — used silently,
// confirmed with the caller, or always asked. Canonical source for the three
// tokens; every Zod schema and type consumes it.
export const INTAKE_SLOT_POLICY_VALUES = [
    'skip',
    'confirm',
    'ask',
];
//# sourceMappingURL=call-flow-config.js.map